import viewingsReducer from './viewings.slice';

export * from './viewings.slice';
export * from './viewings.thunk';

export default viewingsReducer;
